<template>
  <section class="p-2">
    <v-card>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form v-model="valid" ref="filter">
            <v-row class="ma-0 ms-0">
              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  v-model="searchFilter.send_country"
                  class="rounded"
                  dense
                  outlined
                  hide-details
                  label="Sender Country"
                  item-text="txt"
                  item-value="val"
                  :items="senderCountrys"
                  @input="getSendCountryPartners(searchFilter.send_country)"
                  :rules="FieldRequired('Sender Country')"
                  placeholder="Sender Country"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  v-model="searchFilter.send_partner"
                  class="rounded"
                  dense
                  outlined
                  label="Channel Partner"
                  item-text="txt"
                  item-value="val"
                  :items="senderPartners"
                  :rules="FieldRequired('Channel Partner')"
                  placeholder="Partner"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  v-model="searchFilter.pay_country"
                  class="rounded"
                  dense
                  outlined
                  hide-details
                  label="Payout Country"
                  item-text="txt"
                  item-value="val"
                  :items="countryOptions"
                  @input="getpartnerTypes(searchFilter.pay_country)"
                  :rules="FieldRequired('Payout Country')"
                  placeholder="Payout Country"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  v-model="searchFilter.pay_partner"
                  class="rounded"
                  dense
                  outlined
                  :items="payoutPartner"
                  label="Payout Partner"
                  placeholder="Partner"
                  item-text="txt"
                  :rules="FieldRequired('Payout Partner')"
                  item-value="val"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-text-field
                  v-model="searchFilter.from_date"
                  type="date"
                  class="rounded"
                  :rules="[validateFromDate]"
                  label="From Date"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-text-field
                  v-model="searchFilter.to_date"
                  :rules="[validateToDate]"
                  type="date"
                  class="rounded"
                  label="To Date"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-1 text-decoration-none"
                color="primary"
                @click="getAllRates()"
                >Get Results</v-btn
              >
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="dessertHeaders"
        :items="RatesSummary"
        :search="search"
        dense
        item-key="rate_id"
      >
        <template v-slot:item.rate_level="{ item }">
          <v-chip label small>
            {{ item.rate_level }}
          </v-chip>
        </template>

        <template v-slot:top>
          <div class="d-flex mt-3">
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              color="primary"
              small
              class="me-5 mt-2"
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-3"
              dense
              clearable
            ></v-text-field>
          </div>
        </template>
      </v-data-table>

      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import setupService from "@/services/SetupService/setupService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  name: "FX Rate History",
  data() {
    return {
      FieldRequired,
      FieldNumbRequired,
      filterNumberInput,
      search: "",
      loader: false,
      showDialog: false,
      showRateDialog: false,
      deleteDialog: false,
      selcted_currency: null,
      selcted_rate_id: null,
      valid: true,
      deleteId: null,
      editedIndex: -1,
      selectedCountry: "MYS",
      payselectedCountry: "IND",
      selectedCurrency: "INR",
      countryOptions: [],
      senderCountrys: [],
      senderPartners: [],
      paymentModesList: [],
      payoutPartner: [],
      partnerCurrency: [],
      dropdown: {
        country_objs: [],
      },
      RatesSummary: [],
      searchFilter: {
        send_partner: null,
        send_country: null,
        pay_partner: null,
        pay_country: null,
        from_date: null,
        to_date: null,
      },
    };
  },
  components: {
    OverlayPageVue,
  },
  watch: {},
  mounted() {
    this.getcountryList();
    this.getAllSendCountrys();
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
    dessertHeaders() {
      return [
        {
          text: `Sending Agent`,
          sortable: false,
          value: "sending_partner",
        },
        { text: "Payout Name", value: "payout_name", sortable: false },
        { text: "Currency", value: "currency", sortable: false },
        // { text: "Payment Mode", value: "payment_mode", sortable: false },
        {
          text: `Cost Rate`,
          value: "cost_rate",
          sortable: false,
        },
        {
          text: `HO Margin`,
          value: "ho_margin",
          sortable: false,
        },
        {
          text: `Settlement Rate`,
          value: "settlement_rate",
          sortable: false,
        },
        {
          text: `Agent Margin`,
          value: "agent_margin",
          sortable: false,
        },
        {
          text: `Txn Rate`,
          value: "txn_rate",
          sortable: false,
        },
        {
          text: `Rate Level`,
          value: "rate_level",
          sortable: false,
        },
        {
          text: `Modified by`,
          value: "modified_by",
          sortable: false,
        },
        {
          text: `Modified date`,
          value: "modified_date",
          sortable: false,
        },
        {
          text: `Created by`,
          value: "created_by",
          sortable: false,
        },
        {
          text: `Created date`,
          value: "created_date",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    validateToDate(value) {
      if (value && this.searchFilter.from_date) {
        return (
          value >= this.searchFilter.from_date ||
          "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    validateFromDate(value) {
      if (value && this.searchFilter.to_date) {
        return (
          value <= this.searchFilter.to_date ||
          "From date cannot be later than To date"
        );
      }
      return true;
    },
    async getAllRates() {
      const validate = this.$refs.filter.validate();
      if (validate) {
        this.loader = true;
        try {
          const response = await setupService.getExchangeRatesHistory(
            this.searchFilter,
          );
          if (response.data.status_code === 200) {
            this.RatesSummary = response.data.data;
            console.log("Rates Data", this.RatesSummary);
            this.dropdown.country_objs.map((ele) => {
              if (ele.iso_alpha3 === this.payselectedCountry) {
                this.selectedCurrency = ele.currency_code;
              }
            });
            this.stoploader();
          } else {
            this.RatesSummary == [];
            this.stoploader();
          }
        } catch (error) {
          this.RatesSummary = [];
          this.stoploader();
          console.error(error);
        }
      }
    },

    async getcountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.countryOptions = response.data.data.map((i) => {
            return { txt: i.name, val: i.iso_alpha3 };
          });
        }
        this.dropdown.country_objs = response.data.data;
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.countryOptions = [];
      }
    },
    async getAllSendCountrys() {
      try {
        const responseData = await partnerService.getAllSenderCountrys();
        if (responseData.data.status_code === 200) {
          this.senderCountrys = responseData.data.data.map((i) => {
            return { txt: i.name, val: i.iso3 };
          });
        }
        console.log("Send Countrys", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getSendCountryPartners(country_code) {
      try {
        const responseData = await partnerService.getCountryPartners(
          country_code,
        );
        if (responseData.data.status_code === 200) {
          this.senderPartners = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
        console.log("Partners", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getpartnerTypes(country_id) {
      try {
        const response = await partnerService.getAllPayoutPartners(country_id);
        if (response.data.status_code === 200) {
          console.log("response.data.data partner", response.data.data);
          this.payoutPartner = response.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.RatesSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.RatesSummary,
          "RatesSummary",
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";

.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
